import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomLabel from '@s-ui/react-atom-label'
import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'

import FormBodyTypeItem from './form-body-type-item.js'

const FORM_BODY_TYPE_LABEL_NAME = 'FormBodyType'
const LEGACY_WRAPPER = 'legacy'

const FormBodyType = ({
  value = [],
  type,
  onChange,
  overlayContentRef,
  options,
  singleSelection = false,
  wrapper = LEGACY_WRAPPER
}) => {
  const {i18n, domain} = useContext(Context)
  const config = domain.get('config')
  const APP_NAME = config.get('APP_NAME')
  const {bodyTypes: configBodyTypes, bodyTypesImages, FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const bodyTypes = options || configBodyTypes
  const localizedBodyTypes = bodyTypes.map(bodyType => {
    return {
      ...bodyType,
      label: i18n.t(bodyType.label),
      imageSrc: bodyType.imageSrc || bodyTypesImages[bodyType.id] || null
    }
  })

  const _handleOnChange = (e, {value: selectedValue}) => {
    const stringSelectedValue = String(selectedValue)
    const isSelected = value.some(activeValue => String(activeValue) === stringSelectedValue)
    let newValue = []

    if (isSelected) {
      newValue = value.filter(activeValue => String(activeValue) !== stringSelectedValue)
    } else {
      newValue = singleSelection ? [selectedValue] : [...value, selectedValue]
    }

    onChange(e, {
      field: FILTER_NAMES.BODY_TYPE,
      value: newValue,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.BODY_TYPE]
    })
  }

  const handleChange = ({value}) => {
    onChange(null, {
      field: FILTER_NAMES.BODY_TYPE,
      value: value.map(Number),
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.BODY_TYPE]
    })
  }

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <div className="mt-FormBodyType">
        <AtomLabel name={FORM_BODY_TYPE_LABEL_NAME} text={i18n.t(`FORM_BODY_TYPE_${APP_NAME}_LABEL`)} />
        <div className="mt-FormBodyType-list" role="group">
          {localizedBodyTypes.map(({id, label}, index) => {
            const isSelected = value.some(selectedValue => String(selectedValue) === String(id))
            return (
              <FormBodyTypeItem id={id} label={label} isSelected={isSelected} onChange={_handleOnChange} key={index} />
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <div className="mt-FormBodyType">
      <FilterWrapperBasic
        filters={[
          {
            label: i18n.t('FORM_BODY_TYPE_COCHES_LABEL'),
            name: FILTER_NAMES.BODY_TYPE,
            options: localizedBodyTypes,
            type
          }
        ]}
        group={`${FILTER_NAMES.BODY_TYPE}Group`}
        legend={i18n.t('FORM_BODY_TYPE_COCHES_LABEL')}
        onChange={handleChange}
        overlayContentRef={overlayContentRef}
        value={{[FILTER_NAMES.BODY_TYPE]: value.filter(item => Boolean(!item.length))}}
        wrapper={wrapper}
      />
    </div>
  )
}

FormBodyType.displayName = 'FormBodyType'
FormBodyType.propTypes = {
  type: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  singleSelection: PropTypes.bool,
  wrapper: PropTypes.string
}

export default FormBodyType
